import { publicRoutes, mobilePublicRoutes } from "./publicRoutes";
import protectedRoutes from "./protectedRoute/protectedRoutes";

const routes = [...publicRoutes, ...protectedRoutes, ...mobilePublicRoutes];
const mobileRoutes = [...mobilePublicRoutes];

export { routes, mobileRoutes };
